import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    /** Inclusive lower bound for the resubmission timestamp (ISO string or epoch millis). */
    start: string | number;
    /** Exclusive upper bound (ISO string or epoch millis); defaults to the current time when omitted. */
    end?: string | number;
    position?: number;
};
export const schemaLoanRequestResolver_GetResubmissionLoanRequestsByDate = z.array(
    LoanRequestsTableDefinitionZod.omit({ antragsteller1: true }).merge(
        z.object({
            antragsteller1: LoanRequestsTableDefinitionZod.shape.antragsteller1.unwrap(),
        }),
    ),
);

export type SchemaLoanRequestResolver_GetResubmissionLoanRequestsByDate = z.infer<
    typeof schemaLoanRequestResolver_GetResubmissionLoanRequestsByDate
>;

export type LoanRequestResolver_GetResubmissionLoanRequestsByDate = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetResubmissionLoanRequestsByDate
>;
